// extracted by mini-css-extract-plugin
export default {"container":"styles_container__yfAWp","textarea":"styles_textarea__5zEq9","textareaWarning":"styles_textarea-warning__noUgQ","warningText":"styles_warning-text__+-y9R"};